import { Maybe } from '@Types'

export const getPhoneNumberTitle = (
    phoneCountryCode: Maybe<number>,
    phoneAreaCode: Maybe<string>,
    phoneNumber: Maybe<string>
) => {
    const code = phoneCountryCode ? phoneCountryCode : ''
    const area = phoneAreaCode ? phoneAreaCode : ''
    const num = phoneNumber ? phoneNumber : ''
    return code + area + num
}

export const getFullPhoneNumberTitle = (phoneCountryCode: Maybe<number>, fullPhoneNumber: Maybe<string>) => {
    const code = phoneCountryCode ? phoneCountryCode : ''
    const fullPhone = fullPhoneNumber ? fullPhoneNumber : ''
    return '+' + code + '-' + fullPhone
}
